import { Modal, Form, Input } from 'antd';
import { func, bool, array } from 'prop-types';

export default function AddEnterpriseModal(props) {
  const {
    open, onOk, onCancel, form, validationRules = [],
  } = props;

  return (
    <Modal
      title="添加企业"
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="applicantName"
          label="企业名称"
          rules={[
            { required: true, message: '请输入企业名称' },
            { whitespace: true, message: '企业名称不能为空' },
          ]}
        >
          <Input placeholder="请输入企业名称" maxLength={100} />
        </Form.Item>
        <Form.Item
          name="applicantNo"
          label="统一社会信用代码"
          rules={[
            { required: true, message: '请输入统一社会信用代码' },
            { whitespace: true, message: '统一社会信用代码不能为空' },
            { pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/, message: '请输入正确的统一社会信用代码格式' },
            ...validationRules,
          ]}
        >
          <Input placeholder="请输入统一社会信用代码" maxLength={18} />
        </Form.Item>
      </Form>
    </Modal>
  );
}

AddEnterpriseModal.propTypes = {
  open: bool.isRequired,
  onOk: func.isRequired,
  onCancel: func.isRequired,
  form: func.isRequired,
  validationRules: array,
};
